import { Action, createReducer, on } from '@ngrx/store';
import { CommCardDetailed } from './../../../api/models/comm-card/comm-card-detailed.model';
import { ToroControllerConfiguration } from './../../../api/models/toro-controller-configuration.model';
import { controllerActionTypes } from './controller.actions';
import { controllerAdapter, ControllerState } from "./controller.entity";

export const initialState = controllerAdapter.getInitialState({
    total: 0,
    loaded: false,
    selectedController: null,
    selectedControllerConfiguration: null,
    selectedControllerComCard: null,
    currentController: null,
    currentStation: null,
    controllerList: null,
    controllerConfigurationList: new Map<number, ToroControllerConfiguration>(),
    controllerCommcardList: new Map<number, CommCardDetailed>(),
    ids: [],
});

export const controllerReducerObj = createReducer(
    initialState,

    on(controllerActionTypes.setControllersForLocation, (state, action) => {
        console.log(action.controllers);

        return {
            ...state,
            controllerList: action.controllers,
            loaded: action.controllers.length > 0,
            total: action.controllers ? action.controllers.length : 0
        }
    }),

    on(controllerActionTypes.setControllersConfiguration, (state, action) => {

        return {
            ...state,
            controllerConfigurationList: action.configurations,
        }
    }),

    on(controllerActionTypes.setControllersCommcard, (state, action) => {
        return {
            ...state,
            controllerCommcardList: action.commcards,
        }
    }),

    on(controllerActionTypes.clear, (state, action) => {
        return controllerAdapter.removeAll(state);
    }),

    on(controllerActionTypes.selectController, (state, action) => {
        return {
            ...state,
            currentController: action.currentController
        };
    }),

    on(controllerActionTypes.selectZone, (state, action) => {
        return {
            ...state,
            currentStation: action.currentStation
        };
    })
);

export function reducer(state: ControllerState = initialState, action: Action): ControllerState {
    return controllerReducerObj(state, action);
}

export const controllerSelectors = controllerAdapter.getSelectors();
